import { render } from "./Castle.vue?vue&type=template&id=a1b03856"
import script from "./Castle.vue?vue&type=script&lang=js"
export * from "./Castle.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__